export default "/images/6ed990622b34566a88f3c37d7e5ff0cc.avif";